(() => {
    let typePage = '';
    let pathsFromRedirect = [
        '/blogs/bebe-prematuro/https//www.who.int/topics/breastfeeding/es/',
        '/blogs/desarrollo-del-nino-1-3-anos/e4-berrinche-infantil'
    ];
    
    let pathsToRedirect = [
        '/pages/desarrollo-del-bebe',
        '/blogs/desarrollo-del-nino-1-3-anos/mom11-e4-berrinche-infantil'
    ];
    
    let urlBaseRedirect = 'https://www.enfabebe.com.mx';

    document.addEventListener("DOMContentLoaded", (ev) => {
        typePage = document.getElementById('type_page');
        pathSearch = window.location.search;

        const redirectIndex = pathsFromRedirect.findIndex(path => window.location.href.includes(path));

        if (redirectIndex !== -1) {
            const targetPath = pathsToRedirect[redirectIndex];
            const redirectUrl = targetPath ? `${urlBaseRedirect}${targetPath}` : `${urlBaseRedirect}`;
            window.location.href = redirectUrl;
            return;
        }
    });
})();